class UdShippingCountdown extends HTMLElement {
  constructor() {
    super();

    this.cutoffMonThu = this.dataset.cutoffTimeMonThuDay || '15:30';
    this.cutoffFriday = this.dataset.cutoffTimeFriday || '14:30';
    this.intervalDays = parseInt(this.dataset.intervalOfTime || '1', 10);
    this.enableTimer = this.dataset.enableCutoffTimer === 'true';

    this.timer = null;
    this.cutoffDate = null;
    this.deliveryDate = null;
    this.deliveryDays = null;
  }

  connectedCallback() {
    this.dateEl = this.querySelector('.ud-delivery-date strong');
    this.countdownEl = this.querySelector('.ud-delivery-countdown strong');

    if (!this.dateEl || !this.countdownEl) return;

    // UKD: Friday-only Saturday delivery nudge (shown before the Friday cutoff)
    this.saturdayEl = this.querySelector('.ud-delivery-saturday');
    if (!this.saturdayEl) {
      this.saturdayEl = document.createElement('div');
      this.saturdayEl.className = 'ud-delivery-saturday';
      this.saturdayEl.style.cssText = 'display:none;font-size:14px;line-height:20px;color:#383836;opacity:.75;margin-top:2px';
      const countdownWrap = this.querySelector('.ud-delivery-countdown');
      if (countdownWrap) countdownWrap.after(this.saturdayEl);
    }

    this.calculateDates();
    this.calculateDeliveryDays();
    this.render();

    if (this.enableTimer) {
      this.timer = setInterval(() => this.render(), 1000);
    }
  }

  disconnectedCallback() {
    // @ts-ignore
    clearInterval(this.timer);
  }

  /* ---------------------------
     TIME HELPERS
  ---------------------------- */

  getNowInUK() {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    }).formatToParts(new Date());

    const v = {};
    // @ts-ignore
    parts.forEach(p => p.type !== 'literal' && (v[p.type] = p.value));

    // @ts-ignore
    return new Date(`${v.year}-${v.month}-${v.day}T${v.hour}:${v.minute}:${v.second}`);
  }

  // @ts-ignore
  parseMinutes(time) {
    const [h, m] = time.split(':').map(Number);
    return h * 60 + m;
  }

  // @ts-ignore
  withTime(base, minutes) {
    const d = new Date(base);
    d.setHours(Math.floor(minutes / 60), minutes % 60, 0, 0);
    return d;
  }

  // @ts-ignore
  nextWorkingDay(date) {
    const d = new Date(date);
    do {
      d.setDate(d.getDate() + 1);
    } while (d.getDay() === 0 || d.getDay() === 6);
    return d;
  }

  // @ts-ignore
  addWorkingDays(start, days) {
    let d = new Date(start);
    let added = 0;

    while (added < days) {
      d = this.nextWorkingDay(d);
      added++;
    }

    return d;
  }

  /* ---------------------------
     CORE DATE LOGIC
  ---------------------------- */

  calculateDates() {
    const now = this.getNowInUK();
    const day = now.getDay();
    const nowMinutes = now.getHours() * 60 + now.getMinutes();

    const monThuCutoff = this.parseMinutes(this.cutoffMonThu);
    const friCutoff = this.parseMinutes(this.cutoffFriday);
    // @ts-ignore
    const cutoffForDay = d => (d === 5 ? friCutoff : monThuCutoff);

    if (day === 0 || day === 6) {
      const monday = this.nextWorkingDay(now);
      this.cutoffDate = this.withTime(monday, monThuCutoff);
    } else {
      const todayCutoff = cutoffForDay(day);

      if (nowMinutes >= todayCutoff) {
        const nextDay = this.nextWorkingDay(now);
        this.cutoffDate = this.withTime(nextDay, cutoffForDay(nextDay.getDay()));
      } else {
        this.cutoffDate = this.withTime(now, todayCutoff);
      }
    }

    this.deliveryDate = this.addWorkingDays(this.cutoffDate, this.intervalDays);
  }

  calculateDeliveryDays() {
    const now = this.getNowInUK();

    // Strip time to avoid partial-day issues
    const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const end = new Date(
      // @ts-ignore
      this.deliveryDate.getFullYear(),
      // @ts-ignore
      this.deliveryDate.getMonth(),
      // @ts-ignore
      this.deliveryDate.getDate()
    );

    // @ts-ignore
    const diffMs = end - start;
    this.deliveryDays = Math.max(0, Math.round(diffMs / (1000 * 60 * 60 * 24)));
  }

  /* ---------------------------
     FORMATTERS
  ---------------------------- */

  // @ts-ignore
  formatCountdown(ms) {
    const totalSeconds = Math.max(0, Math.floor(ms / 1000));

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (hours <= 0 && minutes <= 0) {
      return `${seconds} second${seconds !== 1 ? 's' : ''}`;
    }

    if (hours <= 0) {
      return `${minutes} minute${minutes !== 1 ? 's' : ''} and ${seconds} second${seconds !== 1 ? 's' : ''}`;
    }

    return `${hours} hour${hours !== 1 ? 's' : ''} and ${minutes} minute${minutes !== 1 ? 's' : ''}`;
  }



  // @ts-ignore
  formatDate(date) {
    const day = date.getDate();
    const month = date.toLocaleString('en-GB', { month: 'long' });

    const suffix =
      day > 3 && day < 21 ? 'th' :
        day % 10 === 1 ? 'st' :
          day % 10 === 2 ? 'nd' :
            day % 10 === 3 ? 'rd' : 'th';

    return `${day}${suffix} ${month}`;
  }
  // @ts-ignore
  formatDeliveryDays(days) {
    const deliveryDate = this.deliveryDate;
    if (days <= 0) return 'Today';
    if (days === 1) return 'Tomorrow';
    // @ts-ignore
    return deliveryDate.toLocaleDateString('en-GB', {
      weekday: 'long'
    });
  }

  /* ---------------------------
     RENDER
  ---------------------------- */

  render() {
    const now = this.getNowInUK();
    // @ts-ignore
    const remaining = this.cutoffDate - now;

    if (remaining <= 0) {
      if (this.timer) clearInterval(this.timer);
      if (this.saturdayEl) this.saturdayEl.style.display = 'none';
      return;
    }

    // if (this.dateEl) this.dateEl.textContent = this.formatDate(this.deliveryDate);
    if (this.dateEl) this.dateEl.textContent = this.formatDeliveryDays(this.deliveryDays);

    if (this.countdownEl) this.countdownEl.textContent = this.formatCountdown(remaining);

    // Saturday nudge: shown while counting down to a Friday cutoff, i.e. from
    // Thursday's cutoff through to Friday's cutoff. Wording depends on the day.
    if (this.saturdayEl) {
      // @ts-ignore
      const countingToFriday = this.cutoffDate.getDay() === 5;
      const today = now.getDay();
      let lead = '';
      if (countingToFriday && today === 4) lead = 'Need it Saturday?';
      if (countingToFriday && today === 5) lead = 'Need it tomorrow?';
      if (lead) {
        this.saturdayEl.innerHTML = lead + ' Choose <span style="font-weight:600;border-bottom:2px solid #FEFF00">Saturday delivery</span> at checkout.';
        this.saturdayEl.style.display = 'block';
      } else {
        this.saturdayEl.style.display = 'none';
      }
    }
  }
}

customElements.define('ud-shipping-countdown', UdShippingCountdown);
